import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Drawer } from '@mui/material';
import Box from '@/components/ui/Box/Box';
import AppErrorSnackbar from '@/components/business/AppErrorSnackbar/AppErrorSnackbar';
import AppToolbar from '@/components/business/AppToolbar/AppToolbar';
import ChatDock from '@/components/business/ChatDock/ChatDock';
import NavDrawer from '@/components/business/NavDrawer/NavDrawer';
import { useCompany } from '@/providers/CompanyProvider/CompanyProvider';
import { styles } from './styles';

export const Layout = () => {
    const location = useLocation();
    const { actions: companyActions } = useCompany();
    const [showDrawer, setShowDrawer] = useState(true);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

    useEffect(() => {
        void companyActions.refreshCompany();
    }, []);

    useEffect(() => {
        setShowDrawer(location.pathname !== '/new_job');
        setMobileDrawerOpen(false);
    }, [location.pathname]);

    return (
        <>
            <AppToolbar
                showMenuButton={showDrawer}
                onMenuClick={() => setMobileDrawerOpen(true)}
            />
            <Box sx={styles.appShell}>
                <AppErrorSnackbar />
                <Box sx={styles.shellInner}>
                    {showDrawer ? (
                        <Box sx={styles.drawerWrap}>
                            <NavDrawer />
                        </Box>
                    ) : (
                        <Box sx={styles.drawerSpacer} />
                    )}
                    <Box sx={styles.outletWrap}>
                        <Outlet />
                    </Box>
                </Box>
            </Box>
            <Drawer
                anchor="left"
                open={mobileDrawerOpen}
                onClose={() => setMobileDrawerOpen(false)}
                sx={styles.mobileDrawer}
            >
                <NavDrawer onItemClick={() => setMobileDrawerOpen(false)} />
            </Drawer>
            <ChatDock />
        </>
    );
};
